/**
 * Google Docs 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <GoogleDocsIcon className="w-8 h-8" />
 * <GoogleDocsIcon className="w-12 h-12" />
 * ```
 */
export function GoogleDocsIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Google Docs icon"
      role="img"
    >
      <title>Google Docs</title>
      <g id="Google Docs">
        <g id="Vector">
          <path
            d="M24.9375 30H7.0625C5.92331 30 5 29.1047 5 28V4C5 2.89533 5.92331 2 7.0625 2H20.125L27 8.66667V28C27 29.1047 26.0767 30 24.9375 30Z"
            fill="#2196F3"
          />
          <path d="M27 8.66667H20.125V2L27 8.66667Z" fill="#BBDEFB" />
          <path d="M20.125 8.66667L27 15.3333V8.66667H20.125Z" fill="#1565C0" />
          <path
            d="M9.8125 15.3333H22.1875V16.6667H9.8125V15.3333ZM9.8125 18H22.1875V19.3333H9.8125V18ZM9.8125 20.6667H22.1875V22H9.8125V20.6667ZM9.8125 23.3333H16.6875V24.6667H9.8125V23.3333Z"
            fill="#E3F2FD"
          />
        </g>
      </g>
    </svg>
  );
}
